(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireec24"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireec24"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("2838M", function(module, exports) {

var $gi2E2 = parcelRequire("gi2E2");

var $769Cg = parcelRequire("769Cg");

var $itvzF = parcelRequire("itvzF");
addEventListener('message', function(event) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $gi2E2._)(function() {
        return (0, $769Cg.__generator)(this, function(_state) {
            (0, $itvzF.initSync)({
                module: event.data.wasmModule
            });
            (0, $itvzF.process_task)(event.data.data, event.data.difficulty, event.data.nonce, event.data.threads);
            return [
                2
            ];
        });
    })();
});

});
parcelRegister("gi2E2", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $bdc060f6523371e4$export$71511d61b312f219; });
function $bdc060f6523371e4$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $bdc060f6523371e4$export$71511d61b312f219(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $bdc060f6523371e4$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $bdc060f6523371e4$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

});

parcelRegister("769Cg", function(module, exports) {

$parcel$export(module.exports, "__generator", function () { return $52b08d845193ff78$export$67ebef60e6f28a6; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ 
var $eXCMu = parcelRequire("eXCMu");
var $52b08d845193ff78$var$extendStatics = function extendStatics1(d, b) {
    $52b08d845193ff78$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $52b08d845193ff78$var$extendStatics(d, b);
};
function $52b08d845193ff78$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $52b08d845193ff78$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $52b08d845193ff78$export$18ce0697a983be9b = function __assign1() {
    $52b08d845193ff78$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $52b08d845193ff78$export$18ce0697a983be9b.apply(this, arguments);
};
function $52b08d845193ff78$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $52b08d845193ff78$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $eXCMu._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $52b08d845193ff78$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $52b08d845193ff78$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $eXCMu._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $52b08d845193ff78$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $52b08d845193ff78$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $eXCMu._)(x)) === "symbol" ? x : "".concat(x);
}
function $52b08d845193ff78$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $eXCMu._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $52b08d845193ff78$export$f1db080c865becb9(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $eXCMu._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $52b08d845193ff78$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $52b08d845193ff78$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $52b08d845193ff78$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $52b08d845193ff78$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $52b08d845193ff78$export$45d3717a4c69092e(o, m, p);
}
function $52b08d845193ff78$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $52b08d845193ff78$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $52b08d845193ff78$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($52b08d845193ff78$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $52b08d845193ff78$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $52b08d845193ff78$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $52b08d845193ff78$export$10c90e4f7922046c(v) {
    return this instanceof $52b08d845193ff78$export$10c90e4f7922046c ? (this.v = v, this) : new $52b08d845193ff78$export$10c90e4f7922046c(v);
}
function $52b08d845193ff78$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $52b08d845193ff78$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $52b08d845193ff78$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $52b08d845193ff78$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $52b08d845193ff78$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $52b08d845193ff78$export$19a8beecd37a4c45 === "function" ? $52b08d845193ff78$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $52b08d845193ff78$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $52b08d845193ff78$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $52b08d845193ff78$var$ownKeys = function ownKeys1(o) {
    $52b08d845193ff78$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $52b08d845193ff78$var$ownKeys(o);
};
function $52b08d845193ff78$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $52b08d845193ff78$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $52b08d845193ff78$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $52b08d845193ff78$var$__setModuleDefault(result, mod);
    return result;
}
function $52b08d845193ff78$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $52b08d845193ff78$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $52b08d845193ff78$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $52b08d845193ff78$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || (typeof receiver === "undefined" ? "undefined" : (0, $eXCMu._)(receiver)) !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $52b08d845193ff78$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if ((typeof value === "undefined" ? "undefined" : (0, $eXCMu._)(value)) !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function dispose() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $52b08d845193ff78$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $52b08d845193ff78$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $52b08d845193ff78$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $52b08d845193ff78$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $52b08d845193ff78$export$2e2bcd8739ae039 = {
    __extends: $52b08d845193ff78$export$a8ba968b8961cb8a,
    __assign: $52b08d845193ff78$export$18ce0697a983be9b,
    __rest: $52b08d845193ff78$export$3c9a16f847548506,
    __decorate: $52b08d845193ff78$export$29e00dfd3077644b,
    __param: $52b08d845193ff78$export$d5ad3fd78186038f,
    __esDecorate: $52b08d845193ff78$export$3a84e1ae4e97e9b0,
    __runInitializers: $52b08d845193ff78$export$d831c04e792af3d,
    __propKey: $52b08d845193ff78$export$6a2a36740a146cb8,
    __setFunctionName: $52b08d845193ff78$export$d1a06452d3489bc7,
    __metadata: $52b08d845193ff78$export$f1db080c865becb9,
    __awaiter: $52b08d845193ff78$export$1050f835b63b671e,
    __generator: $52b08d845193ff78$export$67ebef60e6f28a6,
    __createBinding: $52b08d845193ff78$export$45d3717a4c69092e,
    __exportStar: $52b08d845193ff78$export$f33643c0debef087,
    __values: $52b08d845193ff78$export$19a8beecd37a4c45,
    __read: $52b08d845193ff78$export$8d051b38c9118094,
    __spread: $52b08d845193ff78$export$afc72e2116322959,
    __spreadArrays: $52b08d845193ff78$export$6388937ca91ccae8,
    __spreadArray: $52b08d845193ff78$export$1216008129fb82ed,
    __await: $52b08d845193ff78$export$10c90e4f7922046c,
    __asyncGenerator: $52b08d845193ff78$export$e427f37a30a4de9b,
    __asyncDelegator: $52b08d845193ff78$export$bbd80228419bb833,
    __asyncValues: $52b08d845193ff78$export$e3b29a3d6162315f,
    __makeTemplateObject: $52b08d845193ff78$export$4fb47efe1390b86f,
    __importStar: $52b08d845193ff78$export$c21735bcef00d192,
    __importDefault: $52b08d845193ff78$export$da59b14a69baef04,
    __classPrivateFieldGet: $52b08d845193ff78$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $52b08d845193ff78$export$d40a35129aaff81f,
    __classPrivateFieldIn: $52b08d845193ff78$export$81fdc39f203e4e04,
    __addDisposableResource: $52b08d845193ff78$export$88ac25d8e944e405,
    __disposeResources: $52b08d845193ff78$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $52b08d845193ff78$export$889dfb5d17574b0b
};

});
parcelRegister("eXCMu", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $ae44a88405106244$export$71511d61b312f219; });
function $ae44a88405106244$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});


parcelRegister("itvzF", function(module, exports) {

$parcel$export(module.exports, "process_task", function () { return $d7336d67281c62aa$export$fcb6bce1d050ce61; });
$parcel$export(module.exports, "initSync", function () { return $d7336d67281c62aa$export$2ec80ee76a9348bf; });

var $gi2E2 = parcelRequire("gi2E2");

var $eXCMu = parcelRequire("eXCMu");

var $769Cg = parcelRequire("769Cg");
var $d7336d67281c62aa$var$wasm;
function $d7336d67281c62aa$var$addToExternrefTable0(obj) {
    var idx = $d7336d67281c62aa$var$wasm.__externref_table_alloc();
    $d7336d67281c62aa$var$wasm.__wbindgen_export_2.set(idx, obj);
    return idx;
}
function $d7336d67281c62aa$var$handleError(f, args) {
    try {
        return f.apply(this, args);
    } catch (e) {
        var idx = $d7336d67281c62aa$var$addToExternrefTable0(e);
        $d7336d67281c62aa$var$wasm.__wbindgen_exn_store(idx);
    }
}
var $d7336d67281c62aa$var$cachedTextDecoder = typeof TextDecoder !== 'undefined' ? new TextDecoder('utf-8', {
    ignoreBOM: true,
    fatal: true
}) : {
    decode: function() {
        throw Error('TextDecoder not available');
    }
};
if (typeof TextDecoder !== 'undefined') $d7336d67281c62aa$var$cachedTextDecoder.decode();
var $d7336d67281c62aa$var$cachedUint8ArrayMemory0 = null;
function $d7336d67281c62aa$var$getUint8ArrayMemory0() {
    if ($d7336d67281c62aa$var$cachedUint8ArrayMemory0 === null || $d7336d67281c62aa$var$cachedUint8ArrayMemory0.byteLength === 0) $d7336d67281c62aa$var$cachedUint8ArrayMemory0 = new Uint8Array($d7336d67281c62aa$var$wasm.memory.buffer);
    return $d7336d67281c62aa$var$cachedUint8ArrayMemory0;
}
function $d7336d67281c62aa$var$getStringFromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return $d7336d67281c62aa$var$cachedTextDecoder.decode($d7336d67281c62aa$var$getUint8ArrayMemory0().subarray(ptr, ptr + len));
}
function $d7336d67281c62aa$var$isLikeNone(x) {
    return x === undefined || x === null;
}
function $d7336d67281c62aa$var$debugString(val) {
    // primitive types
    var type = typeof val === "undefined" ? "undefined" : (0, $eXCMu._)(val);
    if (type == 'number' || type == 'boolean' || val == null) return "".concat(val);
    if (type == 'string') return '"'.concat(val, '"');
    if (type == 'symbol') {
        var description = val.description;
        if (description == null) return 'Symbol';
        else return "Symbol(".concat(description, ")");
    }
    if (type == 'function') {
        var name = val.name;
        if (typeof name == 'string' && name.length > 0) return "Function(".concat(name, ")");
        else return 'Function';
    }
    // objects
    if (Array.isArray(val)) {
        var length = val.length;
        var debug = '[';
        if (length > 0) debug += $d7336d67281c62aa$var$debugString(val[0]);
        for(var i = 1; i < length; i++)debug += ', ' + $d7336d67281c62aa$var$debugString(val[i]);
        debug += ']';
        return debug;
    }
    // Test for built-in
    var builtInMatches = /\[object ([^\]]+)\]/.exec(toString.call(val));
    var className;
    if (builtInMatches && builtInMatches.length > 1) className = builtInMatches[1];
    else // Failed to match the standard '[object ClassName]'
    return toString.call(val);
    if (className == 'Object') // we're a user defined class or Object
    // JSON.stringify avoids problems with cycles, and is generally much
    // easier than looping through ownProperties of `val`.
    try {
        return 'Object(' + JSON.stringify(val) + ')';
    } catch (_) {
        return 'Object';
    }
    // errors
    if (val instanceof Error) return "".concat(val.name, ": ").concat(val.message, "\n").concat(val.stack);
    // TODO we could test for more things here, like `Set`s and `Map`s.
    return className;
}
var $d7336d67281c62aa$var$WASM_VECTOR_LEN = 0;
var $d7336d67281c62aa$var$cachedTextEncoder = typeof TextEncoder !== 'undefined' ? new TextEncoder('utf-8') : {
    encode: function() {
        throw Error('TextEncoder not available');
    }
};
var $d7336d67281c62aa$var$encodeString = typeof $d7336d67281c62aa$var$cachedTextEncoder.encodeInto === 'function' ? function encodeString(arg, view) {
    return $d7336d67281c62aa$var$cachedTextEncoder.encodeInto(arg, view);
} : function(arg, view) {
    var buf = $d7336d67281c62aa$var$cachedTextEncoder.encode(arg);
    view.set(buf);
    return {
        read: arg.length,
        written: buf.length
    };
};
function $d7336d67281c62aa$var$passStringToWasm0(arg, malloc, realloc) {
    if (realloc === undefined) {
        var buf = $d7336d67281c62aa$var$cachedTextEncoder.encode(arg);
        var ptr = malloc(buf.length, 1) >>> 0;
        $d7336d67281c62aa$var$getUint8ArrayMemory0().subarray(ptr, ptr + buf.length).set(buf);
        $d7336d67281c62aa$var$WASM_VECTOR_LEN = buf.length;
        return ptr;
    }
    var len = arg.length;
    var ptr1 = malloc(len, 1) >>> 0;
    var mem = $d7336d67281c62aa$var$getUint8ArrayMemory0();
    var offset = 0;
    for(; offset < len; offset++){
        var code = arg.charCodeAt(offset);
        if (code > 0x7F) break;
        mem[ptr1 + offset] = code;
    }
    if (offset !== len) {
        if (offset !== 0) arg = arg.slice(offset);
        ptr1 = realloc(ptr1, len, len = offset + arg.length * 3, 1) >>> 0;
        var view = $d7336d67281c62aa$var$getUint8ArrayMemory0().subarray(ptr1 + offset, ptr1 + len);
        var ret = $d7336d67281c62aa$var$encodeString(arg, view);
        offset += ret.written;
        ptr1 = realloc(ptr1, len, offset, 1) >>> 0;
    }
    $d7336d67281c62aa$var$WASM_VECTOR_LEN = offset;
    return ptr1;
}
var $d7336d67281c62aa$var$cachedDataViewMemory0 = null;
function $d7336d67281c62aa$var$getDataViewMemory0() {
    if ($d7336d67281c62aa$var$cachedDataViewMemory0 === null || $d7336d67281c62aa$var$cachedDataViewMemory0.buffer.detached === true || $d7336d67281c62aa$var$cachedDataViewMemory0.buffer.detached === undefined && $d7336d67281c62aa$var$cachedDataViewMemory0.buffer !== $d7336d67281c62aa$var$wasm.memory.buffer) $d7336d67281c62aa$var$cachedDataViewMemory0 = new DataView($d7336d67281c62aa$var$wasm.memory.buffer);
    return $d7336d67281c62aa$var$cachedDataViewMemory0;
}
function $d7336d67281c62aa$export$b3571188c770cc5a() {
    $d7336d67281c62aa$var$wasm.start();
}
function $d7336d67281c62aa$export$fcb6bce1d050ce61(data, difficulty, thread_id, threads) {
    var ptr0 = $d7336d67281c62aa$var$passStringToWasm0(data, $d7336d67281c62aa$var$wasm.__wbindgen_malloc, $d7336d67281c62aa$var$wasm.__wbindgen_realloc);
    var len0 = $d7336d67281c62aa$var$WASM_VECTOR_LEN;
    $d7336d67281c62aa$var$wasm.process_task(ptr0, len0, difficulty, thread_id, threads);
}
function $d7336d67281c62aa$var$__wbg_load(module, imports) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $gi2E2._)(function() {
        var e, bytes, instance;
        return (0, $769Cg.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(typeof Response === 'function' && module instanceof Response)) return [
                        3,
                        7
                    ];
                    if (!(typeof WebAssembly.instantiateStreaming === 'function')) return [
                        3,
                        4
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        WebAssembly.instantiateStreaming(module, imports)
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
                case 3:
                    e = _state.sent();
                    if (module.headers.get('Content-Type') != 'application/wasm') console.warn("`WebAssembly.instantiateStreaming` failed because your server does not serve Wasm with `application/wasm` MIME type. Falling back to `WebAssembly.instantiate` which is slower. Original error:\n", e);
                    else throw e;
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        4,
                        module.arrayBuffer()
                    ];
                case 5:
                    bytes = _state.sent();
                    return [
                        4,
                        WebAssembly.instantiate(bytes, imports)
                    ];
                case 6:
                    return [
                        2,
                        _state.sent()
                    ];
                case 7:
                    return [
                        4,
                        WebAssembly.instantiate(module, imports)
                    ];
                case 8:
                    instance = _state.sent();
                    if (instance instanceof WebAssembly.Instance) return [
                        2,
                        {
                            instance: instance,
                            module: module
                        }
                    ];
                    else return [
                        2,
                        instance
                    ];
                    _state.label = 9;
                case 9:
                    return [
                        2
                    ];
            }
        });
    })();
}
function $d7336d67281c62aa$var$__wbg_get_imports() {
    var imports = {};
    imports.wbg = {};
    imports.wbg.__wbg_call_672a4d21634d4a24 = function() {
        return $d7336d67281c62aa$var$handleError(function(arg0, arg1) {
            var ret = arg0.call(arg1);
            return ret;
        }, arguments);
    };
    imports.wbg.__wbg_instanceof_DedicatedWorkerGlobalScope_a688e81380e34e02 = function(arg0) {
        var result;
        try {
            result = arg0 instanceof DedicatedWorkerGlobalScope;
        } catch (_) {
            result = false;
        }
        var ret = result;
        return ret;
    };
    imports.wbg.__wbg_new_405e22f390576ce2 = function() {
        var ret = new Object();
        return ret;
    };
    imports.wbg.__wbg_newnoargs_105ed471475aaf50 = function(arg0, arg1) {
        var ret = new Function($d7336d67281c62aa$var$getStringFromWasm0(arg0, arg1));
        return ret;
    };
    imports.wbg.__wbg_postMessage_83a8d58d3fcb6c13 = function() {
        return $d7336d67281c62aa$var$handleError(function(arg0, arg1) {
            arg0.postMessage(arg1);
        }, arguments);
    };
    imports.wbg.__wbg_set_3f1d0b984ed272ed = function(arg0, arg1, arg2) {
        arg0[arg1] = arg2;
    };
    imports.wbg.__wbg_static_accessor_GLOBAL_88a902d13a557d07 = function() {
        var ret = typeof $parcel$global === 'undefined' ? null : $parcel$global;
        return $d7336d67281c62aa$var$isLikeNone(ret) ? 0 : $d7336d67281c62aa$var$addToExternrefTable0(ret);
    };
    imports.wbg.__wbg_static_accessor_GLOBAL_THIS_56578be7e9f832b0 = function() {
        var ret = typeof globalThis === 'undefined' ? null : globalThis;
        return $d7336d67281c62aa$var$isLikeNone(ret) ? 0 : $d7336d67281c62aa$var$addToExternrefTable0(ret);
    };
    imports.wbg.__wbg_static_accessor_SELF_37c5d418e4bf5819 = function() {
        var ret = typeof self === 'undefined' ? null : self;
        return $d7336d67281c62aa$var$isLikeNone(ret) ? 0 : $d7336d67281c62aa$var$addToExternrefTable0(ret);
    };
    imports.wbg.__wbg_static_accessor_WINDOW_5de37043a91a9c40 = function() {
        var ret = typeof window === 'undefined' ? null : window;
        return $d7336d67281c62aa$var$isLikeNone(ret) ? 0 : $d7336d67281c62aa$var$addToExternrefTable0(ret);
    };
    imports.wbg.__wbindgen_debug_string = function(arg0, arg1) {
        var ret = $d7336d67281c62aa$var$debugString(arg1);
        var ptr1 = $d7336d67281c62aa$var$passStringToWasm0(ret, $d7336d67281c62aa$var$wasm.__wbindgen_malloc, $d7336d67281c62aa$var$wasm.__wbindgen_realloc);
        var len1 = $d7336d67281c62aa$var$WASM_VECTOR_LEN;
        $d7336d67281c62aa$var$getDataViewMemory0().setInt32(arg0 + 4, len1, true);
        $d7336d67281c62aa$var$getDataViewMemory0().setInt32(arg0 + 0, ptr1, true);
    };
    imports.wbg.__wbindgen_init_externref_table = function() {
        var table = $d7336d67281c62aa$var$wasm.__wbindgen_export_2;
        var offset = table.grow(4);
        table.set(0, undefined);
        table.set(offset + 0, undefined);
        table.set(offset + 1, null);
        table.set(offset + 2, true);
        table.set(offset + 3, false);
    };
    imports.wbg.__wbindgen_is_undefined = function(arg0) {
        var ret = arg0 === undefined;
        return ret;
    };
    imports.wbg.__wbindgen_number_new = function(arg0) {
        var ret = arg0;
        return ret;
    };
    imports.wbg.__wbindgen_string_new = function(arg0, arg1) {
        var ret = $d7336d67281c62aa$var$getStringFromWasm0(arg0, arg1);
        return ret;
    };
    imports.wbg.__wbindgen_throw = function(arg0, arg1) {
        throw new Error($d7336d67281c62aa$var$getStringFromWasm0(arg0, arg1));
    };
    return imports;
}
function $d7336d67281c62aa$var$__wbg_init_memory(imports, memory) {}
function $d7336d67281c62aa$var$__wbg_finalize_init(instance, module) {
    $d7336d67281c62aa$var$wasm = instance.exports;
    $d7336d67281c62aa$var$__wbg_init.__wbindgen_wasm_module = module;
    $d7336d67281c62aa$var$cachedDataViewMemory0 = null;
    $d7336d67281c62aa$var$cachedUint8ArrayMemory0 = null;
    $d7336d67281c62aa$var$wasm.__wbindgen_start();
    return $d7336d67281c62aa$var$wasm;
}
function $d7336d67281c62aa$export$2ec80ee76a9348bf(module) {
    if ($d7336d67281c62aa$var$wasm !== undefined) return $d7336d67281c62aa$var$wasm;
    if (typeof module !== 'undefined') {
        if (Object.getPrototypeOf(module) === Object.prototype) module = module.module;
        else console.warn('using deprecated parameters for `initSync()`; pass a single object instead');
    }
    var imports = $d7336d67281c62aa$var$__wbg_get_imports();
    $d7336d67281c62aa$var$__wbg_init_memory(imports);
    if (!(module instanceof WebAssembly.Module)) module = new WebAssembly.Module(module);
    var instance = new WebAssembly.Instance(module, imports);
    return $d7336d67281c62aa$var$__wbg_finalize_init(instance, module);
}

function $d7336d67281c62aa$var$__wbg_init(module_or_path) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $gi2E2._)(function() {
        var imports, _ref, instance, module;
        return (0, $769Cg.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if ($d7336d67281c62aa$var$wasm !== undefined) return [
                        2,
                        $d7336d67281c62aa$var$wasm
                    ];
                    if (typeof module_or_path !== 'undefined') {
                        if (Object.getPrototypeOf(module_or_path) === Object.prototype) module_or_path = module_or_path.module_or_path;
                        else console.warn('using deprecated parameters for the initialization function; pass a single object instead');
                    }
                    if (typeof module_or_path === 'undefined') module_or_path = new URL((parcelRequire("hmXoP")));
                    imports = $d7336d67281c62aa$var$__wbg_get_imports();
                    if (typeof module_or_path === 'string' || typeof Request === 'function' && module_or_path instanceof Request || typeof URL === 'function' && module_or_path instanceof URL) module_or_path = fetch(module_or_path);
                    $d7336d67281c62aa$var$__wbg_init_memory(imports);
                    return [
                        4,
                        module_or_path
                    ];
                case 1:
                    return [
                        4,
                        $d7336d67281c62aa$var$__wbg_load.apply(void 0, [
                            _state.sent(),
                            imports
                        ])
                    ];
                case 2:
                    _ref = _state.sent(), instance = _ref.instance, module = _ref.module;
                    return [
                        2,
                        $d7336d67281c62aa$var$__wbg_finalize_init(instance, module)
                    ];
            }
        });
    })();
}
var $d7336d67281c62aa$export$2e2bcd8739ae039 = $d7336d67281c62aa$var$__wbg_init;

});
parcelRegister("hmXoP", function(module, exports) {
module.exports = $parcel$resolve("4RDch");

});



var $9e766d59a66d30f2$exports = {};
$parcel$extendImportMap({
    "4RDch": "pow_bg.e56bb07e.wasm"
});


parcelRequire("2838M");
})();
//# sourceMappingURL=pow.worker.8c3779b0.js.map
